export enum TabsMenuOptionsRoutes {
  Dados = "dados",
  Endereco = "endereço",
  Documentos = "documentos",
  Contratos = "contratos",

}

export const TabMenuOptions: {
  label: string;
  route: TabsMenuOptionsRoutes;
  permission?: string;
}[] = [
    {
      label: "Dados Cadastrais",
      route: TabsMenuOptionsRoutes.Dados,
    },
    {
      label: "Endereço",
      route: TabsMenuOptionsRoutes.Endereco,
    },
    {
      label: "Documentos",
      route: TabsMenuOptionsRoutes.Documentos,
    },
    {
      label: "Contratos",
      route: TabsMenuOptionsRoutes.Contratos,
    },

  ];
